<div class="page-layout blank fullwidth-warranty-list p-12">
<div class="wc-list-container">
  <!-- Header -->
  <div class="wc-header">
    <!-- <i class="material-icons back-icon">arrow_back</i> -->
     <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" class="svg-img">
      <g clip-path="url(#clip0_1_185)">
      <path d="M8.24219 0.285158C8.00781 0.0390639 7.65625 -0.0546861 7.32813 0.0312514C7 0.117189 6.7461 0.378908 6.66016 0.707033L6.04297 3.14844L3.62109 2.46485C3.29297 2.37109 2.94141 2.46484 2.70313 2.70313C2.46484 2.94141 2.37109 3.29297 2.46485 3.62109L3.14844 6.04297L0.707033 6.66406C0.378908 6.7461 0.121095 7.00391 0.0312514 7.33203C-0.0585923 7.66016 0.0390639 8.00781 0.285158 8.24219L2.08985 10L0.285158 11.7578C0.0390639 11.9922 -0.0546861 12.3438 0.0312514 12.6719C0.117189 13 0.378908 13.2539 0.707033 13.3398L3.14844 13.957L2.46485 16.3789C2.37109 16.707 2.46484 17.0586 2.70313 17.2969C2.94141 17.5352 3.29297 17.6289 3.62109 17.5352L6.04297 16.8516L6.66016 19.293C6.74219 19.6211 7 19.8789 7.32813 19.9688C7.65625 20.0586 8.00391 19.9609 8.24219 19.7188L10 17.9141L11.7578 19.7188C11.9961 19.9609 12.3438 20.0586 12.6719 19.9688C13 19.8789 13.2539 19.6211 13.3398 19.293L13.957 16.8516L16.3789 17.5352C16.707 17.6289 17.0586 17.5352 17.2969 17.2969C17.5352 17.0586 17.6289 16.707 17.5352 16.3789L16.8516 13.957L19.293 13.3398C19.6211 13.2578 19.8789 13 19.9688 12.6719C20.0586 12.3438 19.9609 11.9961 19.7188 11.7578L17.9141 10L19.7188 8.24219C19.9609 8.00391 20.0586 7.65625 19.9688 7.32813C19.8789 7 19.6211 6.7461 19.293 6.66016L16.8516 6.04297L17.5352 3.62109C17.6289 3.29297 17.5352 2.94141 17.2969 2.70313C17.0586 2.46484 16.707 2.37109 16.3789 2.46485L13.957 3.14844L13.3359 0.707033C13.2539 0.378908 12.9961 0.121095 12.668 0.0312514C12.3398 -0.0585923 11.9922 0.0390639 11.7578 0.285158L10 2.08985L8.24219 0.285158Z" fill="white"/>
      </g>
      <defs>
      <clipPath id="clip0_1_185">
      <path d="M0 0H20V20H0V0Z" fill="white"/>
      </clipPath>
      </defs>
     </svg>
     <div style="display: grid;">
      <span class="title">Warranty Certificates</span>
      <svg width="96" height="4" viewBox="0 0 96 4" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M94 0C95.1046 0 96 0.895431 96 2C96 3.10457 95.1046 4 94 4H2C0.895431 4 0 3.10457 0 2C0 0.895431 0.895431 0 2 0H94Z" fill="url(#paint0_linear_1_189)"/>
        <path d="M94 0C95.1046 0 96 0.895431 96 2C96 3.10457 95.1046 4 94 4H2C0.895431 4 0 3.10457 0 2C0 0.895431 0.895431 0 2 0H94Z" stroke="#E5E7EB"/>
        <defs>
        <linearGradient id="paint0_linear_1_189" x1="0" y1="2" x2="96" y2="2" gradientUnits="userSpaceOnUse">
        <stop stop-color="#FACC15"/>
        <stop offset="1" stop-color="#CA8A04"/>
        </linearGradient>
        </defs>
      </svg>
     </div>
  </div>

  <!-- Search Bar -->
  <div class="main-class-from-search">
    <div [ngClass]="isMobile ? 'wc-search-mobile' : 'wc-search-desktop'">
      <input
        type="text"
        [(ngModel)]="searchText"
        (keydown.enter)="filterCertificates()"
        (input)="filterCertificates()"
        (click)="filterCertificates()"
      />
      <!-- Clear Button -->
      <span 
        class="wc-clear-btn" 
        *ngIf="searchText.length > 0"
        (click)="clearSearch()"
      >✖</span>
      <!-- Scrolling Placeholder Animation -->
      <div class="wc-scroll-text-container">

          <div class="wc-search-icon">
            <i class="material-icons" class="wc-search-icon">search</i>
          </div>

          <div class="wc-scroll-text" [class.hidden]="hideScrollText">

            <div id="wc-anim-1" class="wc-anim-text">Search By "Car Number"</div>
            <div id="wc-anim-2" class="wc-anim-text">Search By "Customer Name"</div>
            <div id="wc-anim-3" class="wc-anim-text">Search By "Mobile Number"</div>
            <div id="wc-anim-4" class="wc-anim-text">Search By "Certificate ID"</div>
          </div>
      </div>
    </div>
    <!-- Certificate Card -->
     <ng-container *ngFor="let item of registeredParts">
        <div class="wc-card" *ngIf="item?.certificateNumber">
          <!-- Card Title -->
          <div class="wc-top">
            <div class="wc-icon-box">
              <!-- <i class="material-icons">workspace_premium</i> -->
              <svg width="18" height="24" viewBox="0 0 18 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_1_21)">
                <path d="M8.14689 0.257812C8.66251 -0.0843758 9.33751 -0.0843758 9.85314 0.257812L10.6875 0.806249C10.9688 0.989062 11.2969 1.07812 11.6297 1.05937L12.6281 0.998437C13.2469 0.960937 13.8281 1.29844 14.1047 1.85156L14.5547 2.74687C14.7047 3.04687 14.9485 3.28594 15.2438 3.43594L16.1485 3.89062C16.7016 4.16719 17.0391 4.74844 17.0016 5.36719L16.9406 6.36562C16.9219 6.69844 17.011 7.03125 17.1938 7.30781L17.7469 8.14219C18.0891 8.65781 18.0891 9.33281 17.7469 9.84844L17.1938 10.6875C17.011 10.9688 16.9219 11.2969 16.9406 11.6297L17.0016 12.6281C17.0391 13.2469 16.7016 13.8281 16.1485 14.1047L15.2531 14.5547C14.9531 14.7047 14.7141 14.9484 14.5641 15.2437L14.1094 16.1484C13.8328 16.7016 13.2516 17.0391 12.6328 17.0016L11.6344 16.9406C11.3016 16.9219 10.9688 17.0109 10.6922 17.1937L9.85783 17.7469C9.3422 18.0891 8.6672 18.0891 8.15158 17.7469L7.31251 17.1937C7.03126 17.0109 6.70314 16.9219 6.37033 16.9406L5.37189 17.0016C4.75314 17.0391 4.17189 16.7016 3.89533 16.1484L3.44533 15.2531C3.29533 14.9531 3.05158 14.7141 2.75626 14.5641L1.85158 14.1094C1.29845 13.8328 0.960951 13.2516 0.998451 12.6328L1.05939 11.6344C1.07814 11.3016 0.989076 10.9688 0.806264 10.6922L0.257826 9.85312C-0.0843613 9.3375 -0.0843613 8.6625 0.257826 8.14687L0.806264 7.3125C0.989076 7.03125 1.07814 6.70312 1.05939 6.37031L0.998451 5.37187C0.960951 4.75312 1.29845 4.17187 1.85158 3.89531L2.74689 3.44531C3.04689 3.29062 3.29064 3.04687 3.44064 2.74687L3.89064 1.85156C4.1672 1.29844 4.74845 0.960937 5.3672 0.998437L6.36564 1.05937C6.69845 1.07812 7.03126 0.989062 7.30783 0.806249L8.14689 0.257812ZM12.75 9C12.75 8.00544 12.3549 7.05161 11.6517 6.34835C10.9484 5.64509 9.99458 5.25 9.00001 5.25C8.00545 5.25 7.05162 5.64509 6.34836 6.34835C5.6451 7.05161 5.25001 8.00544 5.25001 9C5.25001 9.99456 5.6451 10.9484 6.34836 11.6516C7.05162 12.3549 8.00545 12.75 9.00001 12.75C9.99458 12.75 10.9484 12.3549 11.6517 11.6516C12.3549 10.9484 12.75 9.99456 12.75 9ZM0.0609512 20.7094L2.08126 15.9047C2.09064 15.9094 2.09533 15.9141 2.10001 15.9234L2.55001 16.8187C3.09845 17.9062 4.23751 18.5672 5.45626 18.4969L6.4547 18.4359C6.46408 18.4359 6.47814 18.4359 6.48751 18.4453L7.32189 18.9984C7.56095 19.1531 7.81408 19.275 8.07658 19.3594L6.31408 23.5453C6.20626 23.8031 5.9672 23.9766 5.69064 24C5.41408 24.0234 5.14689 23.8969 4.99689 23.6625L3.48751 21.3516L0.857826 21.7406C0.590639 21.7781 0.323451 21.6703 0.154701 21.4594C-0.0140488 21.2484 -0.0468613 20.9578 0.0562637 20.7094H0.0609512ZM11.686 23.5406L9.92345 19.3594C10.186 19.275 10.4391 19.1578 10.6781 18.9984L11.5125 18.4453C11.5219 18.4406 11.5313 18.4359 11.5453 18.4359L12.5438 18.4969C13.7625 18.5672 14.9016 17.9062 15.45 16.8187L15.9 15.9234C15.9047 15.9141 15.9094 15.9094 15.9188 15.9047L17.9438 20.7094C18.0469 20.9578 18.0094 21.2437 17.8453 21.4594C17.6813 21.675 17.4094 21.7828 17.1422 21.7406L14.5125 21.3516L13.0031 23.6578C12.8531 23.8922 12.586 24.0187 12.3094 23.9953C12.0328 23.9719 11.7938 23.7938 11.686 23.5406Z" fill="white"/>
                </g>
                <defs>
                <clipPath id="clip0_1_21">
                <path d="M0 0H18V24H0V0Z" fill="white"/>
                </clipPath>
                </defs>
              </svg>
            </div>
            <p class="wc-cert-id">Certificate# {{ item?.certificateNumber }}</p>

            <button class="wc-view-btn" (click)="goToDetails(item)">
              <i class="material-icons">visibility</i> View Certificate
            </button>
          </div>
          <!-- Car + Mobile -->
          <div class="wc-row">
            <div class="wc-col">
              <i class="material-icons car-icon">directions_car</i>
              <div>
                <p class="label">Car Number</p>
                <p class="value">{{ item?.registrationNumber }}</p>
              </div>
            </div>

            <div class="wc-col">
              <i class="material-icons phone-icon">call</i>
              <div>
                <p class="label">Mobile Number</p>
                <p class="value">{{ item?.userMobile }}</p>
              </div>
            </div>
          </div>
          <!-- Name + Date -->
          <div class="wc-row">
            <div class="wc-col">
              <i class="material-icons user-icon">person</i>
              <div>
                <p class="label">Customer Name</p>
                <p class="value">{{ item?.userName | titlecase}}</p>
              </div>
            </div>

            <div class="wc-col">
              <i class="material-icons date-icon">event</i>
              <div>
                <p class="label">Issued On</p>
                <p class="value">{{ item?.createdAt | date:'MMMM d, y' }}</p>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
  </div>
</div>
